module.exports = __webpack_public_path__ + "static/media/gadget_white.8b2d6ec4.svg";